<template>
  <div class="browse-season">
    <h3>{{ season.title }}</h3>
    <ul>
      <li v-for="episode in season.episodes" :key="episode.airedEpisodeNumber" >
        <router-link :to="{ path: `/Browse/Season/${season.airedSeason}/Episode/${episode.airedEpisodeNumber}` }">
          E{{ episode.airedEpisodeNumber }} - <strong>{{ episode.episodeName }}</strong>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'browse-season',
  props: ['seasonNumber'],
  data() {
    return {
      season: this.$store.getters.season(this.seasonNumber)
    };
  }
};
</script>

<style scoped>
.browse-season {
  display: flex;
  justify-content: center;
}

li {
  text-align: left;
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// BrowseSeason.vue?125459f4